export default "__VITE_ASSET__CVUkAiJC__"